import type { FunctionComponent } from 'react';

import AlternatingText from 'components/AlternatingText';
import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

import usePaidByBankAccepted from './usePaidByBankAccepted';

const PaidByBankAccepted: FunctionComponent = () => {
  const { subtitleArray, line2 } = usePaidByBankAccepted();
  return (
    <PleaseWaitOverlay
      icon="check-circle-color"
      title="We have successfully received your open banking payment"
      labelLine1={<AlternatingText array={subtitleArray} />}
      labelLine2={line2}
    />
  );
};

export default PaidByBankAccepted;
